import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

// --- Type helpers for DB tables ---
export type Profile = {
  id: string
  name: string
  email: string
  phone: string | null
  balance: number
  pending_balance: number
  level: string
  role: 'admin' | 'user'
  avatar: string | null
  notes: string | null
  created_at: string
  kyc_status: '未認證' | '審核中' | '已通過' | '已拒絕'
  kyc_real_name: string | null
  kyc_id_number: string | null
  kyc_front_photo: string | null
  kyc_back_photo: string | null
  kyc_holding_photo: string | null
  kyc_submitted_at: string | null
  kyc_reviewed_at: string | null
  kyc_admin_note: string | null
  experience_active: boolean
  total_orders: number
}

export type Product = {
  id: string
  name: string
  region: string
  category: string
  cost_price: number
  distribution_price: number
  normal_price: number
  core_price: number
  dealer_price: number
  suggested_price: number
  stock: number
  images: string[]
  description: string | null
  is_hot: boolean
  is_new: boolean
  is_on_sale: boolean
  tags: string[]
  created_at: string
  updated_at: string
}

export type Order = {
  id: string
  user_id: string
  user_name: string
  total_amount: number
  status: '待付款' | '待發貨' | '已發貨' | '已完成' | '已取消'
  tracking_number: string | null
  shipping_address: string | null
  remark: string | null
  created_at: string
  shipped_at: string | null
}

export type OrderItem = {
  id: string
  order_id: string
  product_id: string | null
  product_name: string
  product_image: string | null
  distribution_price: number
  suggested_price: number
  quantity: number
  created_at: string
}

export type Transaction = {
  id: string
  user_id: string
  type: '儲值' | '扣款' | '體驗金回收'
  amount: number
  balance: number
  description: string | null
  created_at: string
}

export type RechargeRequest = {
  id: string
  user_id: string
  user_name: string | null
  user_email: string | null
  amount: number
  transfer_code: string
  voucher_url: string | null
  status: '待審核' | '通過' | '拒絕'
  admin_note: string | null
  created_at: string
  reviewed_at: string | null
}

export type Withdrawal = {
  id: string
  user_id: string
  user_name: string | null
  amount: number
  bank_name: string
  bank_branch: string
  bank_account: string
  account_holder: string
  status: '待審核' | '已完成' | '已退回'
  admin_note: string | null
  created_at: string
  reviewed_at: string | null
}

export type KycSubmission = {
  id: string
  user_id: string
  user_name: string | null
  user_email: string | null
  real_name: string
  id_number: string
  front_photo: string
  back_photo: string
  holding_photo: string | null
  status: '待審核' | '已通過' | '已拒絕'
  admin_note: string | null
  submitted_at: string
  reviewed_at: string | null
}

export type SystemSettings = {
  id: number
  site_line_url: string
  bank_name: string
  account_name: string
  account_number: string
  bank_branch: string
  recharge_note: string
  updated_at: string
}